export var ProgressBarHeight;
(function (ProgressBarHeight) {
    ProgressBarHeight["XSmall"] = "S100";
    ProgressBarHeight["Small"] = "S200";
    ProgressBarHeight["Default"] = "S300";
    ProgressBarHeight["Large"] = "S400";
    ProgressBarHeight["XLarge"] = "S500";
})(ProgressBarHeight || (ProgressBarHeight = {}));
